// D:\project_Dustre\DustreFront\src\pages\ClientPanel\Products\ProductsModal\NewProductModal.tsx

import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled, { keyframes } from 'styled-components'; // Importar 'styled' e 'keyframes'

import {
  ModalOverlay,
  ModalContent,
  CloseButton,
  Input,
  Label,
  FieldGroup,
  ButtonGroup,
  Tag,
  TagsContainer,
  GradButton,
  GradContainer,
  ImportButton,
  CancelButton,
  SaveButton,
  SuggestionsContainer,
  SuggestionsList,
  SuggestionItem,
} from './stylemodal';

import CloseIcon from '../../../../assets/produtcss/close.svg'
import importIcon from '../../../../assets/produtcss/importtwo.svg'
import saveIcon from '../../../../assets/produtcss/saveprodut.svg'

import ImportPatternModal from '../Importmodal/ImportPatternModal'
// -----------------------------------------------------------
// NOVOS COMPONENTES E ESTILOS PARA A NOTIFICAÇÃO
// -----------------------------------------------------------

const fadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(20px); }
`;

const NotificationContainer = styled.div`
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #4CAF50; /* Verde para sucesso */
  color: white;
  padding: 15px 25px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  animation: ${fadeInOut} 4s ease-in-out forwards; /* 4 segundos de animação */
  display: flex;
  align-items: center;
  gap: 10px;
`;

// Opcional: Adicionar um ícone de "check" ou similar, se tiver um SVG
const CheckIcon = styled.img`
  width: 20px;
  height: 20px;
`;

// -----------------------------------------------------------
// FIM DOS NOVOS COMPONENTES E ESTILOS PARA A NOTIFICAÇÃO
// -----------------------------------------------------------


// Interfaces para os dados da Coleção, Família, Cores e Tipo (GroupBackend)
interface CollectionBackend {
  id: number;
  name: string;
}

interface FamilyBackend {
  id: number;
  name: string;
}

interface TypeBackend {
  id: number;
  name: string;
}

interface ColorBackend {
  id: number;
  name: string;
  hexCode?: string;
}

interface ProductToEditType {
  id?: number;
  code?: string;
  name: string;
  collection: string;
  family: string;
  type: string;
  colors: string[];
  gradValues: (string | number)[];
  pricing: string;
  status?: boolean;
}

interface NewProductModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: /*(product: {
    id?: number;
    name: string;
    collection: string;
    family: string;
    type: string;
    colors: string[];
    gradValues: (string | number)[];
    pricing: string;
    status?: boolean;
  }) => Promise<void> |*/ any;
  productToEdit: ProductToEditType | null;
}

const NewProductModal: React.FC<NewProductModalProps> = ({
  isOpen,
  onClose,
  onSave,
  productToEdit,
}) => {
  const [name, setName] = useState('');
  const [collection, setCollection] = useState('');
  const [collectionId, setCollectionId] = useState<number | null>(null);
  const [family, setFamily] = useState('');
  const [familyId, setFamilyId] = useState<number | null>(null);
  const [type, setType] = useState('');
  const [typeId, setTypeId] = useState<number | null>(null);

  const [colors, setColors] = useState<ColorBackend[]>([]);
  const [colorInput, setColorInput] = useState('');

  const [colorSuggestions, setColorSuggestions] = useState<ColorBackend[]>([]);
  const [showColorSuggestions, setShowColorSuggestions] = useState(false);
  const colorInputRef = useRef<HTMLInputElement>(null);
  const colorSuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const [gradValues, setGradValues] = useState<(string | number)[]>([]);
  const [pricingInput, setPricingInput] = useState('');
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const [collectionSuggestions, setCollectionSuggestions] = useState<
    CollectionBackend[]
  >([]);
  const [showCollectionSuggestions, setShowCollectionSuggestions] =
    useState(false);
  const collectionInputRef = useRef<HTMLInputElement>(null);
  const collectionSuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const [familySuggestions, setFamilySuggestions] = useState<FamilyBackend[]>(
    [],
  );
  const [showFamilySuggestions, setShowFamilySuggestions] = useState(false);
  const familyInputRef = useRef<HTMLInputElement>(null);
  const familySuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const [typeSuggestions, setTypeSuggestions] = useState<TypeBackend[]>([]);
  const [showTypeSuggestions, setShowTypeSuggestions] = useState(false);
  const typeInputRef = useRef<HTMLInputElement>(null);
  const typeSuggestionsContainerRef = useRef<HTMLUListElement>(null);

  const debounceTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // NOVO ESTADO para a notificação
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');

  // Efeito para gerenciar o tempo de exibição da notificação
  useEffect(() => {
    if (showNotification) {
      const timer = setTimeout(() => {
        setShowNotification(false);
        setNotificationMessage('');
      }, 3000); // Notificação visível por 3 segundos

      return () => clearTimeout(timer);
    }
  }, [showNotification]);

  const debouncedFetchColorSuggestions = useCallback(
    (query: string) => {
      if (!familyId) {
        setColorSuggestions([]);
        return;
      }
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const url = new URL(
            `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/families/${familyId}/colors`,
          );
          url.searchParams.append('name', query);
          const response = await fetch(url.toString());
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `Erro ao buscar sugestões de cor: ${response.status} ${response.statusText} - ${errorText}`,
            );
          }
          const data: { colors: ColorBackend[] } = await response.json();
          setColorSuggestions(data.colors || []);
          setShowColorSuggestions((data.colors || []).length > 0);
        } catch (error) {
          console.error('Erro ao buscar sugestões de cor:', error);
          setColorSuggestions([]);
          setShowColorSuggestions(false);
        }
      }, 300);
    },
    [familyId],
  );

  const fetchTypeIdByName = useCallback(async (typeName: string, familyId: number) => {
    try {
      const url = new URL(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/groups`,
      );
      url.searchParams.append('name', typeName);
      url.searchParams.append('familyId', String(familyId));

      const response = await fetch(url.toString());
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(
          `Erro ao buscar ID do tipo: ${response.status} ${response.statusText} - ${errorText}`,
        );
      }
      const data: TypeBackend[] = await response.json();
      const matchedType = data.find((t) => t.name === typeName);
      if (matchedType) {
        setTypeId(matchedType.id);
        return matchedType.id;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Erro ao buscar ID do tipo:', error);
      return null;
    }
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (productToEdit) {
        setName(productToEdit.name || '');
        setCollection(productToEdit.collection || '');
        setFamily(productToEdit.family || '');
        setType(productToEdit.type || '');
        setGradValues(productToEdit.gradValues || []);
        setPricingInput(productToEdit.pricing || '');

        const fetchIdsAndColors = async () => {
          try {
            if (productToEdit.collection) {
              const collectionsRes = await fetch(
                `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/collections?name=${encodeURIComponent(
                  productToEdit.collection,
                )}`,
              );
              const collectionsData: CollectionBackend[] = await collectionsRes.json();
              const matchedCollection = collectionsData.find(
                (c) => c.name === productToEdit.collection,
              );
              if (matchedCollection) {
                setCollectionId(matchedCollection.id);
                if (productToEdit.family) {
                  const familiesRes = await fetch(
                    `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/families?name=${encodeURIComponent(
                      productToEdit.family,
                    )}&collectionId=${matchedCollection.id}`,
                  );
                  const familiesData: FamilyBackend[] = await familiesRes.json();
                  const matchedFamily = familiesData.find(
                    (f) => f.name === productToEdit.family,
                  );
                  if (matchedFamily) {
                    setFamilyId(matchedFamily.id);
                    
                    // Busca as cores do backend para a família
                    const colorsRes = await fetch(
                      `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/families/${matchedFamily.id}/colors`,
                    );
                    const colorsData: { colors: ColorBackend[] } = await colorsRes.json();
                    
                    // Mapeia as cores do produto para os objetos de cor do backend
const colorsWithIds = productToEdit.colors
    .map((colorName) => {
        const trimmedColorName = colorName.trim(); // <--- Adicionada esta linha
        const matchedColor = (colorsData.colors || []).find(
            (c) => c.name.trim() === trimmedColorName, // <--- Ajustada a comparação
        );
        return matchedColor || { name: colorName, id: -Math.random() };
    });
                    // Remove duplicatas e define o estado com os IDs corretos
                    const uniqueColors = Array.from(new Map(colorsWithIds.map(item => [item.id, item])).values());
                    setColors(uniqueColors);

                    if (productToEdit.type) {
                      await fetchTypeIdByName(productToEdit.type, matchedFamily.id);
                    }
                  } else {
                    console.log('[DEBUG - Modal] Família não encontrada:', productToEdit.family);
                  }
                } else {
                  console.log('[DEBUG - Modal] Produto sem família definida');
                }
              } else {
                console.log('[DEBUG - Modal] Coleção não encontrada:', productToEdit.collection);
              }
            } else {
              console.log('[DEBUG - Modal] Produto sem coleção definida');
            }
          } catch (error) {
            console.error('[DEBUG - Modal] Erro ao buscar IDs:', error);
          }
        };

        fetchIdsAndColors();
      } else {
        // Reset para novo produto
        setName('');
        setCollection('');
        setCollectionId(null);
        setFamily('');
        setFamilyId(null);
        setType('');
        setTypeId(null);
        setColors([]);
        setColorInput('');
        setGradValues([]);
        setPricingInput('');
      }
      setCollectionSuggestions([]);
      setShowCollectionSuggestions(false);
      setFamilySuggestions([]);
      setShowFamilySuggestions(false);
      setTypeSuggestions([]);
      setShowTypeSuggestions(false);
    }
  }, [productToEdit, isOpen, fetchTypeIdByName]);

  const debouncedFetchCollectionSuggestions = useCallback((query: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = setTimeout(async () => {
      try {
        const url = `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/collections?name=${encodeURIComponent(
          query,
        )}`;
        const response = await fetch(url);
        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(
            `Erro ao buscar sugestões de coleção: ${response.status} ${response.statusText} - ${errorText}`,
          );
        }
        const data: CollectionBackend[] = await response.json();
        setCollectionSuggestions(data);
        setShowCollectionSuggestions(data.length > 0);
      } catch (error) {
        console.error('Erro ao buscar sugestões de coleção:', error);
        setCollectionSuggestions([]);
        setShowCollectionSuggestions(false);
      }
    }, 300);
  }, []);

  const debouncedFetchFamilySuggestions = useCallback(
    (query: string) => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const url = new URL(
            `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/families`,
          );
          url.searchParams.append('name', query);
          if (collectionId) {
            url.searchParams.append('collectionId', String(collectionId));
          }
          const response = await fetch(url.toString());
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `Erro ao buscar sugestões de família: ${response.status} ${response.statusText} - ${errorText}`,
            );
          }
          const data: FamilyBackend[] = await response.json();
          setFamilySuggestions(data);
          setShowFamilySuggestions(data.length > 0);
        } catch (error) {
          console.error('Erro ao buscar sugestões de família:', error);
          setFamilySuggestions([]);
          setShowFamilySuggestions(false);
        }
      }, 300);
    },
    [collectionId],
  );

  const debouncedFetchTypeSuggestions = useCallback(
    (query: string) => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      debounceTimeoutRef.current = setTimeout(async () => {
        try {
          const url = new URL(
            `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend-fashion-orders/fashion-product/groups`,
          );
          url.searchParams.append('name', query);
          if (familyId) {
            url.searchParams.append('familyId', String(familyId));
          }
          const response = await fetch(url.toString());
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              `Erro ao buscar sugestões de tipo: ${response.status} ${response.statusText} - ${errorText}`,
            );
          }
          const data: TypeBackend[] = await response.json();
          setTypeSuggestions(data);
          setShowTypeSuggestions(data.length > 0);
        } catch (error) {
          console.error('Erro ao buscar sugestões de tipo:', error);
          setTypeSuggestions([]);
          setShowTypeSuggestions(false);
        }
      }, 300);
    },
    [familyId],
  );

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        collectionInputRef.current &&
        !collectionInputRef.current.contains(event.target as Node) &&
        collectionSuggestionsContainerRef.current &&
        !collectionSuggestionsContainerRef.current.contains(
          event.target as Node,
        )
      ) {
        setShowCollectionSuggestions(false);
      }
      if (
        familyInputRef.current &&
        !familyInputRef.current.contains(event.target as Node) &&
        familySuggestionsContainerRef.current &&
        !familySuggestionsContainerRef.current.contains(event.target as Node)
      ) {
        setShowFamilySuggestions(false);
      }
      if (
        typeInputRef.current &&
        !typeInputRef.current.contains(event.target as Node) &&
        typeSuggestionsContainerRef.current &&
        !typeSuggestionsContainerRef.current.contains(event.target as Node)
      ) {
        setShowTypeSuggestions(false);
      }
      if (
        colorInputRef.current &&
        !colorInputRef.current.contains(event.target as Node) &&
        colorSuggestionsContainerRef.current &&
        !colorSuggestionsContainerRef.current.contains(event.target as Node)
      ) {
        setShowColorSuggestions(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectColorSuggestion = (selectedColor: ColorBackend) => {
    if (!colors.some((color) => color.id === selectedColor.id)) {
      setColors((prevColors) => [...prevColors, selectedColor]);
    }
    setColorInput('');
    setColorSuggestions([]);
    setShowColorSuggestions(false);
  };

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newColorValue = e.target.value;
    setColorInput(newColorValue);
    debouncedFetchColorSuggestions(newColorValue);
  };

  const handleColorFocus = () => {
    debouncedFetchColorSuggestions(colorInput);
    setShowColorSuggestions(true);
  };

  const handleAddColor = () => {
    const trimmed = colorInput.trim();
    if (trimmed && !colors.some(c => c.name === trimmed)) {
      const newColor = { name: trimmed, id: -Math.random() };
      setColors(prevColors => [...prevColors, newColor]);
    }
    setColorInput('');
  };

  const handleRemoveColor = (colorToRemove: ColorBackend) => {
    setColors(colors.filter((color) => color.id !== colorToRemove.id));
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      handleAddColor();
    }
  };

  const toggleGrad = (val: string | number) => {
  if (gradValues.includes(val)) {
    setGradValues(gradValues.filter((v) => v !== val));
  } else {
    setGradValues(
      [...gradValues, val].sort((a, b) => {
        const isANumber = typeof a === 'number';
        const isBNumber = typeof b === 'number';

        if (isANumber && isBNumber) {
          return a - b;
        }

        if (isANumber) {
          return -1;
        }

        if (isBNumber) {
          return 1;
        }

        return String(a).localeCompare(String(b));
      }),
    );
  }
};

  const handleSave = async () => {
    if (
      !name.trim() ||
      !collection.trim() ||
      !family.trim() ||
      !type.trim() ||
      !pricingInput.trim()
    ) {
      alert(
        'Por favor, preencha todos os campos obrigatórios (Nome, Coleção, Família, Tipo, Precificação).',
      );
      return;
    }

    const cleanPricing = pricingInput
      .replace('R$', '')
      .replace(/\./g, '')
      .replace(',', '.')
      .trim();
    const parsedPricing = parseFloat(cleanPricing);

    if (isNaN(parsedPricing)) {
      alert(
        'Precificação inválida. Por favor, insira um valor numérico válido.',
      );
      return;
    }

    const colorNames = colors.map((color) => color.name);

    const productData = {
      id: productToEdit?.id,
      name,
      collection,
      family,
      type,
      colors: colorNames,
      gradValues,
      pricing: parsedPricing.toString(),
      status:
        productToEdit?.id !== undefined
          ? productToEdit.status !== undefined
            ? productToEdit.status
            : true
          : true,
    };

    try {
      await onSave(productData);
      setNotificationMessage('Produto salvo com sucesso!'); // Define a mensagem
      setShowNotification(true); // Exibe a notificação
      onClose(); // Fecha o modal após salvar (se essa for a intenção)
    } catch (error) {
      console.error('Erro ao tentar salvar produto no modal:', error);
      alert('Erro ao salvar produto. Verifique o console para mais detalhes.');
      setNotificationMessage('Erro ao salvar produto!'); // Mensagem de erro
      setShowNotification(true); // Exibe a notificação de erro também
    }
  };

  const handleSelectCollectionSuggestion = (
    selectedCollection: CollectionBackend,
  ) => {
    setCollection(selectedCollection.name);
    setCollectionId(selectedCollection.id);
    setFamily('');
    setFamilyId(null);
    setType('');
    setTypeId(null);
    setShowCollectionSuggestions(false);
    setCollectionSuggestions([]);
  };

  const handleCollectionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCollectionValue = e.target.value;
    setCollection(newCollectionValue);
    setCollectionId(null);
    setFamily('');
    setFamilyId(null);
    setType('');
    setTypeId(null);
    debouncedFetchCollectionSuggestions(newCollectionValue);
  };

  const handleCollectionFocus = () => {
    debouncedFetchCollectionSuggestions(collection);
    setShowCollectionSuggestions(true);
  };

  const handleSelectFamilySuggestion = (selectedFamily: FamilyBackend) => {
    setFamily(selectedFamily.name);
    setFamilyId(selectedFamily.id);
    setType('');
    setTypeId(null);
    setShowFamilySuggestions(false);
    setFamilySuggestions([]);
    setColors([]);
    setColorInput('');
  };

  const handleFamilyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFamilyValue = e.target.value;
    setFamily(newFamilyValue);
    setFamilyId(null);
    setType('');
    setTypeId(null);
    setColors([]);
    setColorInput('');
    debouncedFetchFamilySuggestions(newFamilyValue);
  };

  const handleFamilyFocus = () => {
    debouncedFetchFamilySuggestions(family);
    setShowFamilySuggestions(true);
  };

  const handleSelectTypeSuggestion = (selectedType: TypeBackend) => {
    setType(selectedType.name);
    setTypeId(selectedType.id);
    setShowTypeSuggestions(false);
    setTypeSuggestions([]);
  };

  const handleTypeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTypeValue = e.target.value;
    setTypeId(null);
    setType(newTypeValue);
    debouncedFetchTypeSuggestions(newTypeValue);
  };

  const handleTypeFocus = () => {
    debouncedFetchTypeSuggestions(type);
    setShowTypeSuggestions(true);
  };

  const formatPricingInput = (value: string) => {
    let val = value.replace(/[^0-9,.]/g, '');
    val = val.replace(/,/g, '.');

    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    if (val.startsWith('0') && val.length > 1 && !val.includes('.')) {
      val = val.substring(1);
    } else if (
      val.length > 1 &&
      val.includes('.') &&
      val.indexOf('.') === 1 &&
      val.startsWith('0')
    ) {
      // Keeps '0.X'
    } else if (val.startsWith('0') && val.length > 1 && val.charAt(1) !== '.') {
      val = parseFloat(val).toString();
    }

    if (val.includes('.')) {
      const [integer, decimal] = val.split('.');
      return `R$ ${integer.replace(
        /\B(?=(\d{3})+(?!\d))/g,
        '.',
      )},${decimal.substring(0, 2)}`;
    } else if (val) {
      return `R$ ${val.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
    } else {
      return '';
    }
  };

  const handlePricingInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value.replace('R$', '').replace(/\./g, '').trim();
    setPricingInput(formatPricingInput(rawValue));
  };

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h2>
            {productToEdit
              ? `Editar produto: ${productToEdit.code || ''}`
              : 'Novo produto'}
          </h2>
          <CloseButton onClick={onClose}>
            <img src={CloseIcon} alt='Fechar' />
          </CloseButton>
        </div>

        <Label>Nome do produto</Label>
        <Input
          placeholder='Digite aqui'
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setName(e.target.value)
          }
          required
        />

        <SuggestionsContainer style={{ marginTop: '20px' }}>
          <Label>Coleção</Label>
          <Input
            ref={collectionInputRef}
            placeholder='Digite aqui'
            value={collection}
            onChange={handleCollectionChange}
            onFocus={handleCollectionFocus}
            autoComplete='off'
            required
          />
          {showCollectionSuggestions && collectionSuggestions.length > 0 && (
            <SuggestionsList ref={collectionSuggestionsContainerRef}>
              {collectionSuggestions.map((sug) => (
                <SuggestionItem
                  key={sug.id}
                  onClick={() => handleSelectCollectionSuggestion(sug)}
                >
                  {sug.name}
                </SuggestionItem>
              ))}
            </SuggestionsList>
          )}
        </SuggestionsContainer>

        <FieldGroup>
          <SuggestionsContainer>
            <Label>Família</Label>
            <Input
              ref={familyInputRef}
              placeholder='Digite aqui'
              value={family}
              onChange={handleFamilyChange}
              onFocus={handleFamilyFocus}
              autoComplete='off'
              required
            />
            {showFamilySuggestions && familySuggestions.length > 0 && (
              <SuggestionsList ref={familySuggestionsContainerRef}>
                {familySuggestions.map((sug) => (
                  <SuggestionItem
                    key={sug.id}
                    onClick={() => handleSelectFamilySuggestion(sug)}
                  >
                    {sug.name}
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )}
          </SuggestionsContainer>

          <SuggestionsContainer>
            <Label>Grupo</Label>
            <Input
              ref={typeInputRef}
              placeholder='Digite aqui'
              value={type}
              onChange={handleTypeChange}
              onFocus={handleTypeFocus}
              autoComplete='off'
              required
            />
            {showTypeSuggestions && typeSuggestions.length > 0 && (
              <SuggestionsList ref={typeSuggestionsContainerRef}>
                {typeSuggestions.map((sug) => (
                  <SuggestionItem
                    key={sug.id}
                    onClick={() => handleSelectTypeSuggestion(sug)}
                  >
                    {sug.name}
                  </SuggestionItem>
                ))}
              </SuggestionsList>
            )}
          </SuggestionsContainer>
        </FieldGroup>

        <Label>Cores</Label>
        <SuggestionsContainer>
          <Input
            ref={colorInputRef}
            placeholder='Digite uma cor ou selecione uma sugestão'
            value={colorInput}
            onChange={handleColorChange}
            onFocus={handleColorFocus}
            onKeyDown={handleKeyDown}
            autoComplete='off'
          />
          {showColorSuggestions && colorSuggestions.length > 0 && (
            <SuggestionsList ref={colorSuggestionsContainerRef}>
              {colorSuggestions.map((sug) => (
                <SuggestionItem
                  key={sug.id}
                  onClick={() => handleSelectColorSuggestion(sug)}
                >
                  {sug.name}
                </SuggestionItem>
              ))}
            </SuggestionsList>
          )}
        </SuggestionsContainer>
        <TagsContainer>
          {colors.map((color) => (
            <Tag key={color.id} onClick={() => handleRemoveColor(color)}>
              {color.name}
              <span style={{ marginLeft: '5px', cursor: 'pointer' }}>x</span>
            </Tag>
          ))}
        </TagsContainer>

        <Label>Graduação</Label>
        <GradContainer>
          {["PP", "P", "M", "G", "GG", "EXG", 36, 38, 40, 42, 44, 46, 48, "Único"].map((value) => (
            <GradButton
              key={value}
              selected={gradValues.includes(value)}
              onClick={() => toggleGrad(value)}
            >
              {value}
            </GradButton>
          ))}
        </GradContainer>

        <Label>Precificação</Label>
        <Input
          placeholder='Digite aqui (ex: 120,00)'
          value={pricingInput}
          onChange={handlePricingInputChange}
          required
        />

        <ButtonGroup>
          <ImportButton onClick={() => setIsImportModalOpen(true)}>
            <img src={importIcon} alt='Importar' />
            Importar padrão
          </ImportButton>
          <CancelButton onClick={onClose}>Cancelar</CancelButton>
          <SaveButton onClick={handleSave}>
            <img src={saveIcon} alt='Salvar' />
            Salvar produto
          </SaveButton>
        </ButtonGroup>
      </ModalContent>

      <ImportPatternModal
        isOpen={isImportModalOpen}
        onClose={() => setIsImportModalOpen(false)}
      />

      {/* ----------------------------------------------------------- */}
      {/* NOVO COMPONENTE DE NOTIFICAÇÃO - Exibido no canto inferior direito */}
      {/* ----------------------------------------------------------- */}
      {showNotification && (
        <NotificationContainer>
          {/* Você pode adicionar um ícone de "check" aqui se tiver um SVG para isso */}
          {/* <CheckIcon src={checkSvgIcon} alt="Sucesso" /> */}
          <span>{notificationMessage}</span>
        </NotificationContainer>
      )}
    </ModalOverlay>
  );
};

export default NewProductModal;